import React, { FunctionComponent } from 'react'
import { useTranslation } from 'next-i18next'
import { Button, Link, Text, Icon } from '@afterpaytouch/core'
import styles from './style.module.scss'

const I18N_NAMESPACE = ['common', 'index']

interface CreditLimitButtonProps {
  openModal: () => void
  isGbRegFlow?: boolean
}

export const CreditLimitButton: FunctionComponent<CreditLimitButtonProps> = ({ openModal, isGbRegFlow = false }) => {
  const { t } = useTranslation(I18N_NAMESPACE)

  if (isGbRegFlow) {
    return (
      <div>
        <Link kind='Underline' onClick={openModal} aria-label={t('index:welcome:existingUser:htmlAttribute:ariaLabel:openModal')} bold={false}>
          <Text renderAs='span' size='S'>
            {t('index:welcome:learnMoreEstAvailable')}
          </Text>
        </Link>
      </div>
    )
  }

  return (
    <>
      <div>
        <Text renderAs='span' size='M' bold>
          {t('index:welcome:existingUser:label:estAvailable')}
        </Text>
        <Button.Link onClick={openModal} aria-label={t('index:welcome:existingUser:htmlAttribute:ariaLabel:openModal')} testNameSpace='credit-limit-button'>
          <span className={styles['ml-0_50']}>
            <Icon.Info
              size='Small'
              role='img'
              title={t('index:welcome:existingUser:htmlAttribute:icon:info:title')}
              description={t('index:welcome:existingUser:htmlAttribute:icon:info:description')}
            />
          </span>
        </Button.Link>
      </div>
    </>
  )
}
